import { ActionTypes } from "../constants/action-types";

/*
LOGGEDIN-USER Action Types with payload
*/


export const loggedInUser = (loginUser) => {
  return {
    type: ActionTypes.LOGGEDIN_USER,
    payload: loginUser,
  };
};

export const openAccountSidebar = (loginUser) => {
  return {
    type: ActionTypes.OPEN_ACCOUNT_SIDEBAR,
    payload: loginUser,
  };
};

export const passMsgToAccountSidebar=(msg)=>{
  return{
    type: ActionTypes.OPEN_ACCOUNT_SIDEBAR_WITH_MSG,
    payload: msg,
  }
};

export const updateAuthCookie = (loginUser) => ({
  type: ActionTypes.UPDATE_AUTH,
  payload: loginUser,
});

export const handleOpeningOfAccountSidebar = (val) => {
  return {
    type: ActionTypes.IS_OPENING_ACCOUNT_SIDEBAR,
    payload: val,
  };
};

export const openAccountSidebarFromPwaHeader = (val) => {
  return {
    type: ActionTypes.OPEN_ACCOUNT_SIDEBAR_PWA_HEADER,
    payload: val,
  };
};

export const closeReactSidebar = (val) => {
  return {
    type: ActionTypes.CLOSE_REACT_SIDEBAR,
    payload: val,
  };
};

export const openForgotSidebar = (val) => {
  return {
    type: ActionTypes.OPEN_FORGOT_SIDEBAR,
    payload: val,
  };
};
